<template>
    <div class="container" id="profile">
        <div class="row">
            <div class="col s12" v-show="!is_profile_loading">
                <div class="card-panel">
                   <div class="row">
                       <div class="col s12" v-if="!is_complete_user_detail">
                           <p style="color: #d33">Please key in the required information in order to register E-Warranty and participate the campaign.</p>
                       </div>
                       <div class="col s12">
                           <h4>My Profile</h4>
                       </div>
                       <div class="col s12">
                           <p class="title">Member ID: {{ userId }}</p>
                       </div>
                       <div class="input-field col s12 m6">
                           <input id="username" placeholder="Your Name" type="text" v-model="$v.username.$model" required>
                           <label for="username">Name</label>
                           <span class="helper-text" v-if="!$v.username.required">Username is required</span>
                       </div>
                       <div class="input-field col s12 m6">
                           <input :disabled="!is_edit_phone" placeholder="Your Phone Number" type="text" v-model="$v.phone_no.$model" required style="display: block">
                           <label for="phone_no">Phone No.</label>
                           <span class="helper-text" v-if="!$v.phone_no.required">Phone Number is required</span>
                           <span class="helper-text" v-if="!$v.phone_no.integer">Phone Number must contain only number</span>
                           <a class="waves-effect waves-light btn-small" v-if="!is_edit_phone" v-on:click="editPhone">Edit</a>
                           <a class="waves-effect waves-light btn-small" v-if="is_edit_phone" v-on:click="verifyPhone">Verify</a>
                           <div class="row" v-if="is_otp_show">
                               <div class="col s12">
                                   <input placeholder="Your OTP Code" type="number" v-model="otp" required style="display: block">
                               </div>
                               <div class="col s12">
                                   <a class="waves-effect waves-light btn-small" v-on:click="verifyOtpAction">Submit</a>
                               </div>
                           </div>
                           <div class="row" v-if="is_otp_verified === 0">
                               <div class="col s12">
                                   <p style="color: #d33">Please verify your phone number by click on Edit button.</p>
                               </div>
                           </div>
                       </div>
                   </div>

                    <div class="row">
                        <div class="input-field col s12 m6">
                            <input id="email" placeholder="Your Email" type="text" v-model="$v.email.$model" required>
                            <label for="email">Email</label>
                            <span class="helper-text" v-if="!$v.email.required">Email is required</span>
                            <span class="helper-text" v-if="!$v.email.isUnique">Email has been taken</span>
                        </div>
                        <div class="col s12 m6">
                            <label for="dob">Date of Birth</label>
                            <div style="position: relative" v-on:click="changeDate">
                                <input v-model="dob" v-if="dob" disabled style="display: block">
                                <i class="material-icons" style="position: absolute; top: 38%; right: 0%; cursor: pointer">edit</i>
                                <span class="helper-text" v-if="!$v.dob.required">Date of Birth is required</span>
                            </div>

                            <span v-if="is_change_date">
                                <select class="browser-default dob" v-model="year">
                                <option value="" disabled selected>Year</option>
                                <option :value="moment().format('YYYY')">{{ moment().format('YYYY') }}</option>
                                <option :value="moment().format('YYYY') - year" v-for="(year) in 100">{{ moment().format('YYYY') - year }}</option>
                            </select>
                            <select class="browser-default dob" v-model="month">
                                <option value="" disabled selected>Month</option>
                                <option value="01">Jan</option>
                                <option value="02">Feb</option>
                                <option value="03">Mar</option>
                                <option value="04">Apr</option>
                                <option value="05">May</option>
                                <option value="06">Jun</option>
                                <option value="07">Jul</option>
                                <option value="08">Aug</option>
                                <option value="09">Sep</option>
                                <option value="10">Oct</option>
                                <option value="11">Nov</option>
                                <option value="12">Dec</option>
                            </select>
                            <select class="browser-default dob" v-model="day">
                                <option value="" disabled selected>Day</option>
                                <option :value="day" v-for="day in 31">{{ day }}</option>
                            </select>
                                <!--<span class="helper-text" v-if="!$v.dob.required">Date of Birth is required</span>-->
                            </span>
                        </div>
                    </div>


                   <div class="row">
                       <div class="col s12">
                           <p class="title">Shipping Address</p>
                       </div>
                       <div class="input-field col s12 m12">
                           <input id="address_line" placeholder="Your Address" type="text" v-model="$v.address_line.$model" required>
                           <label for="address_line">Address</label>
                           <span class="helper-text" v-if="!$v.address_line.required">Address Line is required</span>
                       </div>
                       <div class="input-field col s12 m12">
                           <input id="city" placeholder="Your City" type="text" v-model="$v.city.$model" required>
                           <label for="city">City</label>
                           <span class="helper-text" v-if="!$v.city.required">City is required</span>
                       </div>
                       <div class="input-field col s12 m6">
                           <input id="postcode" placeholder="Your Postcode" type="text" v-model="$v.postcode.$model" required>
                           <label for="postcode">Postcode</label>
                           <span class="helper-text" v-if="!$v.postcode.required">Postcode is required</span>
                       </div>
                       <div class="input-field col s12 m6" style="margin-top: 0">
                           <label style="position: relative; left: 0">State</label>
                           <select name="state" class="browser-default" v-model="$v.state_id.$model">
                               <option value="0" disabled selected>Choose your state</option>
                               <option value="1">Johor</option>
                               <option value="2">Kedah</option>
                               <option value="3">Kelantan</option>
                               <option value="4">Kuala Lumpur</option>
                               <option value="5">Melaka</option>
                               <option value="6">Negeri Sembilan</option>
                               <option value="7">Pahang</option>
                               <option value="8">Perak</option>
                               <option value="9">Perlis</option>
                               <option value="10">Perak</option>
                               <option value="11">Pulau Pinang</option>
                               <option value="12">Sabah</option>
                               <option value="13">Sarawak</option>
                               <option value="14">Selangor</option>
                               <option value="15">Terengganu</option>
                               <option value="16">Labuan</option>
                               <option value="17">Putrajaya</option>
                           </select>
                           <span class="helper-text" v-if="!$v.state_id.required || !$v.state_id.maxValue">State is required</span>
                       </div>
                   </div>
                    <div class="input-field col s12 m12">
                        <p>
                            <label>
                                <input type="checkbox" class="filled-in" v-model="is_subscribe_news"/>
                                <span>I hereby agree to receive personalized information and commercial offers from <b>Groupe SEB Malaysia</b> and that I hereby agree to the terms and conditions of <b>Groupe SEB Malaysia's</b> <a target="_blank" href="https://www.tefal.com.my/privacy">Privacy Policy</a> which is stated in. I understand that my personal data is processed by <b>Groupe SEB Malaysia's</b> and in order to send me the marketing communications, my personal data may be transferred outside my country of origin. I can withdraw my consent to receive such communication at any time. For more information (including how to withdraw your consent), please refer to <a target="_blank" href="https://www.tefal.com.my/privacy">Privacy Policy</a> page.</span>
                            </label>
                        </p>
                    </div>

                   <div class="row">
                       <div class="col s12 right-align">
                           <button v-if="!is_update_loading" class="btn waves-effect waves-light" v-on:click="updateProfile">Update
                               <i class="material-icons right">edit</i>
                           </button>
                           <a v-if="is_update_loading" class="btn waves-effect waves-light disabled"><i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></a>
                       </div>
                   </div>
               </div>
            </div>

            <div class="col s12 center-align" v-show="is_profile_loading">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true" style="font-size: 2.5rem; margin-top: 2rem"></i>
            </div>

            <div class="col s12" v-if="purchase_histories.length > 0">
                <div class="card-panel">
                    <div class="row">
                        <div class="col s12">
                            <p class="title">In-store Purchased History</p>
                        </div>

                        <div class="col s12">
                            <p style="font-size: 12px; color: #9e9e9e">Note: Product purchased in Tefal Offical Store wil be automatic registered in E-Warranty within <span style="color: red">7 business working days</span>.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <table class="responsive-table">
                                <thead>
                                <tr>
                                    <th>Sale ID</th>
                                    <th>Item Code</th>
                                    <th>Model</th>
                                    <th>Product Name</th>
                                    <th>Quantity</th>
                                    <th>Outlet</th>
                                    <th>Purchase Date</th>
                                    <th>Status</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="purchase_history in purchase_histories">
                                    <td>{{ purchase_history.saleId }}</td>
                                    <td>{{ purchase_history.itemCode }}</td>
                                    <td>{{ purchase_history.model }}</td>
                                    <td>{{ purchase_history.itemName }}</td>
                                    <td>{{ purchase_history.quantity }}</td>
                                    <td>{{ purchase_history.outlet }}</td>
                                    <td>{{ moment(purchase_history.purchaseDate).format('YYYY-MM-DD') }}</td>
                                    <td>{{ purchase_history.status }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col s12 center-align" v-if="is_loading">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true" style="font-size: 2.5rem; margin-top: 2rem"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength, between, integer, email, minValue } from 'vuelidate/lib/validators'
import DropdownDatepicker from 'vue-dropdown-datepicker'
const greaterThanZero = (value) => value > 0
export default {
    name: "ProfileComponent",
    components: {
        DropdownDatepicker
    },
    props: [
        'siteUrl',
        'userId',
        'getPurchaseHistoryUrl',
        'getUser',
        'postUpdateProfile',
        'postEmail',
        'sendOtp',
        'verifyOtp'
    ],
    data() {
        return {
            username: '',
            phone_no: '',
            address_line: '',
            postcode: '',
            city: '',
            dob: null,
            is_subscribe_news: false,
            state_id: null,
            is_loading: false,
            is_profile_loading: false,
            is_update_loading: false,
            purchase_histories: [],
            email: '',
            is_edit_phone: false,
            is_complete_user_detail: false,

            is_otp_show: false,
            otp: '',
            is_otp_verified: 0,
            year: '',
            month: '',
            day: '',

            is_change_date: false
        }
    },
    validations: {
        username: {
            required,
        },
        phone_no: {
            required,
            integer
        },
        dob: {
            required
        },
        address_line: {
            required
        },
        city: {
            required
        },
        postcode: {
            required
        },
        state_id: {
            required,
            maxValue: greaterThanZero
        },
        email: {
            required,
            async isUnique(value) {
                // standalone validator ideally should not assume a field is required
                if (value === '') return true

                // simulate async call, fail for all logins with even length
                const response = await axios.post(this.postEmail, {
                    email: value,
                    user_id: this.userId
                }).then(function (response) {

                    return !response.data.is_contain

                }).catch(function (error){

                });

                return await response;
            }
        },
    },
    watch: {
        year (val) {
            if (this.day !== '' && this.month !== '' && this.year !== '')
            {
                this.dob = this.year + '-' + this.month + '-' + this.day
            }
        },
        month (val) {
            if (this.day !== '' && this.month !== '' && this.year !== '')
            {
                this.dob = this.year + '-' + this.month + '-' + this.day
            }
        },
        day (val) {
            if (this.day !== '' && this.month !== '' && this.year !== '')
            {
                this.dob = this.year + '-' + this.month + '-' + this.day
            }
        },
    },
    mounted () {
        this.getPurchaseHistoryLists();
        this.getProfile();
    },
    methods: {
        changeDate () {
            this.is_change_date = true
        },
        onChangeDate (day, month, year) {
            if (day !== 'll' && month !== 'll' && year !== 'll')
            {
                this.dob = year + '-' + month + '-' + day
            }
        },
        verifyPhone () {
          let me = this;
            console.log(this.phone_no)

            axios.post(this.sendOtp, {

                phone_no: this.phone_no

            }).then(function (response) {
                if (response.data.success)
                {
                    me.is_otp_show = true
                }
                else {
                    Swal.fire({
                        position: 'center',
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'Cancel'
                    })
                }
            }).catch(function (error){

            });
        },
        verifyOtpAction () {
            let me = this

            axios.post(this.verifyOtp, {
                otp: this.otp,
                phone_no: this.phone_no
            }).then(function (response) {
                if (response.data.success)
                {
                    location.reload()
                }
                else {
                    var toastHTML = '<span>Error. Something went wrong</button>';
                    M.toast({html: toastHTML, classes: 'red'});
                }
            }).catch(function (error){

            });
        },
        editPhone () {
            this.is_edit_phone = true
            this.phone_no = ''
        },
        status(validation) {
            return {
                error: validation.$error,
                dirty: validation.$dirty
            }
        },
        getPurchaseHistoryLists() {
            let me = this;
            this.is_loading = true;

            axios.get(this.getPurchaseHistoryUrl, {
                params: {
                    user_id: this.userId,
                }
            }).then(function (response) {
                me.purchase_histories = response.data.post_system_purchased_items;
                me.is_loading = false;
            }).catch(function (error){

                me.is_loading = false;
            });
        },
        getProfile() {
            let me = this;
            this.is_profile_loading = true;
            axios.get(this.getUser, {
                params: {
                    user_id: this.userId
                }
            }).then(function (response) {

                me.username = response.data.user.name;
                me.phone_no = response.data.user.phone_no;
                me.address_line = response.data.user.address_line;
                me.postcode = response.data.user.postcode;
                me.state_id = response.data.user.state_id;
                me.city = response.data.user.city;
                me.dob = response.data.user.dob;
                me.is_subscribe_news = (response.data.user.is_subscribe_news === 1 ) ? true : false;
                me.is_profile_loading = false;
                me.email = response.data.user.email;
                me.is_complete_user_detail = response.data.user.is_complete_user_detail;
                me.is_otp_verified = response.data.user.is_otp_verified;

            }).catch(function (error){

                me.is_profile_loading = false;
            });
        },
        updateProfile() {

            let me = this;

            if (this.$v.$invalid) {
                return false;
            }

            this.is_update_loading = true;

            axios.post(this.postUpdateProfile, {
                username: this.username,
                phone_no: this.phone_no,
                address_line: this.address_line,
                postcode: this.postcode,
                state_id: this.state_id,
                city: this.city,
                dob: this.dob,
                is_subscribe_news: this.is_subscribe_news,
                email: this.email

            }).then(function (response) {
                if (response.data)
                {
                    var toastHTML = '<span>Profile updated</button>';
                    M.toast({html: toastHTML, classes: 'green'});
                    let myParam = location.search.split('edit_profile=')[1]
                    console.log(myParam)
                    if (myParam)
                    {
                        window.location.href = '/e-warranty/registration'
                    }
                }
                else {
                    var toastHTML = '<span>Error. Something went wrong</button>';
                    M.toast({html: toastHTML, classes: 'red'});
                }

                me.is_update_loading = false;
            }).catch(function (error){

                me.is_update_loading = false;
            });
        }
    }
}
</script>

<style scoped>

</style>
